import styled from "styled-components";
import { ModalVerticalOverflowWrapper } from "../Modal/styled";
import WrapperContainer from "../Containers/WrapperContainer";

export const DiscardModalWrapper = styled.div`
  ${ModalVerticalOverflowWrapper} {
    padding-bottom: 0 !important;
  }
`;

export const CheckboxWrapper = styled(WrapperContainer)`
  cursor: pointer;

  label {
    cursor: pointer;
  }
`;
